import { IFRAME_AND_CONTAINER_IDS } from "../constants";
import { loadIframe } from "../utils";

export const loadGetAQuoteComponent = () => {
    const { tt: { config: { iframeBaseUrl, dealerId } } } = window;
    const iframeSrc = `${iframeBaseUrl}/integrations/get-a-quote/${dealerId}`;
    const { getAQuote } = IFRAME_AND_CONTAINER_IDS;
    loadIframe({
        src: iframeSrc,
        iframeAndContainerIds: getAQuote,
    });
};
